import { createContext } from 'reka-ui'
import { ref, type Ref } from 'vue'
import type { GlobalSearchSession } from '../state/global-search-session'
import type { RecentSearchStore } from '../state/recent-search-storage'

// Context keys live in this dedicated module (not index.ts) so the
// provider component and the barrel don't form a circular import.

export interface GlobalSearchDialogContext {
  openSearchCommand: () => void
  closeSearchCommand: () => void
  isSearchCommandOpen: Ref<boolean>
}

const [_useGlobalSearchDialog, provideGlobalSearchDialog] =
  createContext<GlobalSearchDialogContext>('gs-global-search')

export { provideGlobalSearchDialog }

/**
 * Open/close handle for the global search dialog. Degrades to no-ops
 * when called outside `GlobalSearchProvider` so optional UI (menu
 * buttons) never throws.
 */
export function useGlobalSearchDialog(): GlobalSearchDialogContext {
  try {
    return _useGlobalSearchDialog()
  } catch {
    console.error('Global search context not found')
    return {
      openSearchCommand: () => {},
      closeSearchCommand: () => {},
      isSearchCommandOpen: ref(false)
    }
  }
}

export const [useGlobalSearch, provideGlobalSearch] =
  createContext<GlobalSearchSession>('gs-global-search-session')

export const [useRecentSearches, provideRecentSearches] =
  createContext<RecentSearchStore>('gs-recent-search-provider')
